/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */
import { mergeMap } from './mergeMap';
export function concatMap(project, resultSelector) {
  return mergeMap(project, resultSelector, 1);
}